const RegisterCountDown = ({ minutes = 0, seconds = 0 }) => {
  return (
    <span>
      {minutes} : {String(seconds).padStart(2, '0')}
    </span>
  );
};

export default RegisterCountDown;
